import React from "react";
import { CGE } from "../../../../common/components/CGE";
import Loading from "../../../../common/components/Loading";
import { beforeMaskedValueChangeRutNoPoint, decode_utf8, isRutValid } from "../../../../common/utils/utilsFunc";
import { useModal } from "@clayui/modal";
import AlertModal from "../../../../common/components/AlertModal";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';

const UserRegister = ({ props , state, setCurrentPage, form, setForm, optionsRelationsSelect,setLoadingReal,ACTIONS,dispatch}) => {

    const [loading, setLoading] = React.useState(false);
    const [valueCheckBoxSubscription, setValueCheckBoxSubscription] = React.useState(true);
    const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
    const [validForm, setValidForm] = React.useState({});
    const [modalInfo, setModalInfo] = React.useState({});
    const [visibleModal, setVisibleModal] = React.useState(false);
    const [visibleModalInfo, setVisibleModalInfo] = React.useState(false);
    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModal(false);
            setVisibleModalInfo(false);
        },
    });
    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);

    let propsLabelInfoContent = {
        "content": state?.webContentTextInfo,
        "observer": observer,
        "onClose": onClose,
        "setVisibleModal": setVisibleModalInfo,
        "status": "info",
        "titleModal": "Información",
        "visibleModal": visibleModalInfo,
        "titleHint": "Ayuda Nro de Cliente",
    }

    function onChangeReCaptcha(value) {
        updateCookieState(value);
        if (value) {
            setVerifReCaptcha(true);
        }
        else {
            setVerifReCaptcha(false);
        }
    }

    function validFormFirstPage() {

        let validForm = {};

        if (form?.rut) {
            if (!isRutValid(form?.rut)) {
                validForm.validateRut = true;
                validForm.msgRut = "Debes ingresar un RUT válido.";
                props.setGlobalAlert("Complete todos los campos obligatorios.","warning");

            }
        } else {
            validForm.validateRut = true;
            validForm.msgRut = "Debes ingresar o RUT";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if (!form?.numberClient) {
            validForm.validateNumberClient = true;
            validForm.msgNumberClient = "Debes ingresar el N° de Cliente";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if (!form?.nameAccount) {
            validForm.validateNameAccount = true;
            validForm.msgNameAccount = "Debes ingresar el Nombre de la Cuenta";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if (!form?.relation) {
            validForm.validateRelation = true;
            validForm.msgRelation = "Debes ingresar la Relación";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if(!verifReCaptcha) {
            validForm.validateVerifReCaptcha = true;
            props.setGlobalAlert("Falta validar que no eres un Robot.","warning");
        }

        setValidForm(validForm);
        return validForm;
    }

    function handleClickFirstPage() {
        const validForm = validFormFirstPage();
        if(Object.keys(validForm)?.length === 0) {
            setLoadingReal(true);
            window.scrollTo({ top: 0, behavior: "smooth" });
            dispatch({ 
                type:ACTIONS.SET_RUT_VERIFY,
                payload:form.rut
            });
            dispatch({ 
                type:ACTIONS.SET_NUMBER_CLIENT_VERIFY,
                payload:form.numberClient
            });

        } else if(validForm === {}) {
            props.setGlobalAlert("El servicio no está disponible actualmente, intente más tarde.", "warning", true, "Advertencia");
        }
    }

    function openModalAuth() {
        setModalInfo({titleModal:"Información",msgModal:state?.webContentTextAuth,status:"info"});
        setVisibleModal(true);
    }

    return (
        <>
            <CGE.Panel title={decode_utf8(props.title_first_page_user_register)}>
                <CGE.PanelSection title={decode_utf8(props.subtitle1_first_page_user_register)}>
                    <div className="row">
                        <div className="col-md-4">
                            <CGE.FormsField
                                handleChange={(e) => setForm({...form,rut:e.target.value })}
                                idFormElement="rut"
                                mandatoryElement={true}
                                labelName="Rut:"
                                placeholder="Rut"
                                typeElement="input-mask"
                                maxLength="12"
                                beforeMaskedValueChange={beforeMaskedValueChangeRutNoPoint}
                                formatChars={{
                                    9: "[0-9]",
                                    k: "[Kk0-9]",
                                }}
                                mask="9999999-kk"
                                maskChar={null}
                                hasError={validForm?.validateRut}
                                msgError={validForm?.msgRut && validForm?.validateRut?validForm?.msgRut:""}
                                value={form?.rut}
                                inputExemple="* Con guión y dígito verificador. Ejemplo: 12345678-9"
                            />
                        </div>
                    </div>
                </CGE.PanelSection>

                <CGE.PanelSection title={decode_utf8(props.subtitle2_first_page_user_register)}>
                    <div className="row">
                        <div className="col-md-4">
                            <CGE.FormsField
                                handleChange={(e) => setForm({...form,numberClient:e.target.value })}
                                idFormElement="inputNumberClient"
                                mandatoryElement={true}
                                typeElement="input-mask"
                                typeFormElement="text"
                                labelName="N° de Cliente (1):"
                                placeholder="N° de Cliente"
                                propsLabelInfoContent={propsLabelInfoContent}
                                formatChars={{
                                    9: "[0-9]"
                                }}
                                mask="999999999999"
                                hasError={validForm?.validateNumberClient}
                                msgError={validForm?.msgNumberClient && validForm?.validateNumberClient?validForm?.msgNumberClient:""}
                                value={form?.numberClient}
                            />
                        </div>
                        <div className="col-md-4">
                            <CGE.FormsField
                                handleChange={(e) => setForm({...form,nameAccount:e.target.value })}
                                idFormElement="inputNameAccount"
                                mandatoryElement={true}
                                typeElement="input"
                                typeFormElement="text"
                                labelName="Nombre de la Cuenta:"
                                placeholder="Nombre de la Cuenta"
                                inputExemple="* Ej. Casa Mamá."
                                hasError={validForm?.validateNameAccount}
                                msgError={validForm?.msgNameAccount && validForm?.validateNameAccount?validForm?.msgNameAccount:""}
                                value={form?.nameAccount}
                                maxLength={100}
                            />
                        </div>
                        <div className="col-md-4">
                            <CGE.FormsField
                                labelName="Relación con número del cliente: "
                                handleChange={(e) => setForm({...form,relation:e.target.value })}
                                idFormElement="numberRelation"
                                typeFormElement="text"
                                mandatoryElement={true}
                                typeElement={'select'}
                                listOptions={optionsRelationsSelect}
                                hasError={validForm.validateRelation}
                                msgError={validForm.msgRelation}
                                placeholder={'Relación con número del cliente'}
                                value={form?.relation}
                            />
                        </div>
                    </div>
                </CGE.PanelSection>
                <CGE.FormsField
                    checked={valueCheckBoxSubscription}
                    labelName="Deseo recibir información de la empresa relacionada al servicio"
                    handleChange={() => setValueCheckBoxSubscription((val) => !val)}
                    idFormElement="inputCheckBoxSubscription"
                    typeFormElement="checkbox"
                    mandatoryElement={false}
                    typeElement="input"
                />
                <CGE.Text
                    size="4"
                    text={decode_utf8(props?.text_info_first_page_user_register) }
                />
                <a onClick={() => openModalAuth()} >Ver Autorización Voluntaria</a>
                <CGE.Spacing type="nl" />
                <CGE.FieldRecaptcha
                    onChange={onChangeReCaptcha}
                    sitekey={props.api_key_recaptcha}
                /> 
                <div className='col-md-12 pt-2 d-flex justify-content-between'>
                    <CGE.Button
                        size="sm"
                        label="Cancelar"
                        type="secondary"
                        href="/"
                    />
                    <CGE.Button
                        size="sm"
                        label="Continuar"
                        onClick={() => handleClickFirstPage()}
                    />
                </div>
            </CGE.Panel>
            {visibleModal && !loading && (
                <AlertModal
                    titleModal={modalInfo?.titleModal}
                    msgModal={modalInfo?.msgModal}
                    observer={observer}
                    onClose={onClose}
                    status={modalInfo?.status}
                />
            )}
            {loading && <Loading />}
        </>
    );
};

export default UserRegister;
